import AutoScroll from "embla-carousel-auto-scroll";
import useEmblaCarousel from "embla-carousel-react";
import { useEffect, useState } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { t } from "../../translations";
import "../styles/embla.css";
import "../styles/sandbox.css";

import Banner1 from "../../assets/Banner_1.png";
import Banner10 from "../../assets/Banner_10.png";
import Banner11 from "../../assets/Banner_11.png";
import Banner12 from "../../assets/Banner_12.png";
import Banner2 from "../../assets/Banner_2.png";
import Banner3 from "../../assets/Banner_3.png";
import Banner4 from "../../assets/Banner_4.png";
import Banner5 from "../../assets/Banner_5.png";
import Banner6 from "../../assets/Banner_6.png";
import Banner7 from "../../assets/Banner_7.png";
import Banner8 from "../../assets/Banner_8.png";
import Banner9 from "../../assets/Banner_9.png";

import { useSelector } from "react-redux";
import "../styles/slide-image.css";

const elements = [
  {
    img: Banner1
  },
  {
    img: Banner2
  },
  {
    img: Banner3
  },
  {
    img: Banner4
  },
  {
    img: Banner5
  },
  {
    img: Banner6
  },
  {
    img: Banner7
  },
  {
    img: Banner8
  },
  {
    img: Banner9
  },
  {
    img: Banner10
  },
  {
    img: Banner11
  },
  {
    img: Banner12
  }
];

const SlideImage = () => {
  // useEffect(() => {}, []);

  const lang = useSelector((state) => state.lang);

  const [emblaRef, emblaApi] = useEmblaCarousel(
    {
      loop: true
    },
    [AutoScroll({ playOnInit: false, stopOnInteraction: false })]
  );
  const [isPlaying, setIsPlaying] = useState(true);

  useEffect(() => {
    const autoScroll = emblaApi?.plugins()?.autoScroll;
    if (!autoScroll) return;
    // toggleAutoplay();
    autoScroll.play();
    setIsPlaying(autoScroll.isPlaying());
    emblaApi
      .on("autoScroll:play", () => setIsPlaying(true))
      .on("autoScroll:stop", () => setIsPlaying(false))
      .on("reInit", () => setIsPlaying(autoScroll.isPlaying()));
  }, [emblaApi]);

  return (
    <div className="slide-image">
      <div className="slide-block">
        <span>{t("banner.taste_of_home", lang)}</span>
      </div>

      <div
        className="embla"
        style={{
          marginTop: 30
        }}
      >
        <div className="embla__viewport" ref={emblaRef}>
          <div className="embla__container">
            {elements.map((item, index) => (
              <div className="embla__slide" key={index}>
                <div className="image-block">
                  <img src={item.img} alt="img-ban" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SlideImage;
